import React from 'react';
import Descriptions from '@uiw/react-descriptions';
import StatusBadge from './../StatusBadge/index';

function Transfer({ vendorType, order, isDetailPage = false }) {
  return (
    <Descriptions bordered size={isDetailPage ? 'large' : 'default'} colon={!isDetailPage}>
      <Descriptions.Item label="Transfer Order #">{order.docNo}</Descriptions.Item>
      <Descriptions.Item label="External Doc #">{order.externalDocumentNo}</Descriptions.Item>
      <Descriptions.Item label="TO Status">
        <StatusBadge status={order.status} />
      </Descriptions.Item>
      {!isDetailPage && (
        <Descriptions.Item label="Receipt Date" span={2}>
          {order.ExpectedReceiptDate}
        </Descriptions.Item>
      )}

      {!isDetailPage && (
        <Descriptions.Item label="No of Lines">{order.itemCount}</Descriptions.Item>
      )}
      <Descriptions.Item label="Place of Origin" span={3}>
        {order.transferFromName}
      </Descriptions.Item>
      <Descriptions.Item label="Destination">{order.transferToName}</Descriptions.Item>
    </Descriptions>
  );
}

export default Transfer;
